; (function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('ConditionalForm', [], factory);
    } else {
        // Browser globals
        root.ConditionalForm = factory();
    }
}(typeof self !== 'undefined' ? self : this, function (Modal) {
        'use strict';

        function Form(element) {
            this.container = element;

            if (!this.container) return;

            this.content = this.container.querySelector('.content');

            this.checkbox = this.container.querySelector('.checkbox > input[type="checkbox"]');

            if (!this.content || !this.checkbox) return;

            this.onchange = this.onchange.bind(this);

            this.checkbox.addEventListener('change', this.onchange)
        }

        Form.prototype = {
            onchange: function (event) {
                if (this.checkbox.checked) {
                    this.content.classList.remove('-hidden');
                } else {
                    this.content.classList.add('-hidden');
                }
            }
        }

        return Form;
}));